import API from "./api";

export class CUITValidatorService {

    public validateCUIT= async (cuit: string, tipoPersona: string) => {
        const res = API.get(`/negocio/validaciones/cuit/${cuit}?tipoPersona=${tipoPersona}`);
        return res.then(async (resp) => {
            return resp;
        })
        .catch(err => {
            return err;
        })
    };

}